import React, { useState } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import publicApi from "../../../services/ApiService";
import { caratProNotifyMeUrl } from "../../../common/config/app.endpoints";

interface SuccessViewProps {
  email?: string;
  usageData?: any;
}

const SuccessView: React.FC<SuccessViewProps> = ({ email, usageData }) => {
  const [isNotifying, setIsNotifying] = useState(false);
  const [hasNotified, setHasNotified] = useState(false);

  const getFreeLeftText = () => {
    if (!usageData) return "1 FREE LEFT";
    if (usageData.limitExceeded) return null;
    const freeLeft = Math.max(0, (usageData.freeSearchLeft ?? 2) - 1);
    if (freeLeft <= 0) return null;
    return `${freeLeft} FREE LEFT`;
  };

  const handleNotifyMe = async () => {
    if (!email) {
      alert("No email address found to notify.");
      return;
    }
    
    setIsNotifying(true);
    const nextState = !hasNotified;
    try {
      await publicApi.post(caratProNotifyMeUrl, {
        email: email,
        notifyMeAtLaunch: nextState
      });
      setHasNotified(nextState);
    } catch (error) {
      const err = error as any;
      console.error("Failed to subscribe to notifications:", err);
      alert(err.response?.data?.message || err.response?.data?.errors?.[0]?.message || "Failed to subscribe. Please try again.");
    } finally {
      setIsNotifying(false);
    }
  };

  return (
    <div style={{ background: '#fff', padding: '4rem 0', color: '#1A1A1A', textAlign: 'center' }}>
      <div style={{ color: '#d92b3c', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '2px', marginBottom: '1.5rem', textTransform: 'uppercase' }}>SUBMITTED</div>
      <div style={{ fontSize: '2.5rem', fontWeight: 'bold', fontFamily: '"Playfair Display", serif', marginBottom: '1rem', color: '#1A1A1A' }}>Thank you.</div>
      <div style={{ color: '#999', fontSize: '0.85rem', lineHeight: '1.6', maxWidth: '380px', margin: '0 auto 3rem auto' }}>
        A Zipang gemologist is reviewing your piece and will send a firm offer within one business day. Watch your inbox.
      </div>

      <div style={{ maxWidth: '480px', margin: '0 auto', background: '#FAFAFA', border: '1px solid #EAEAEA', borderRadius: '8px', padding: '2rem', textAlign: 'left', marginBottom: '2rem' }}>
        <div style={{ color: '#d92b3c', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '1px', marginBottom: '1rem', textTransform: 'uppercase' }}>
          CARAT PRO &middot; COMING IN SEPTEMBER
        </div>
        <div style={{ color: '#1A1A1A', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: '1rem' }}>
          The engine that priced your piece, opening to anyone who wants to check one — whether or not they sell with us. One email when it's live.
        </div>
        <div style={{ color: '#1A1A1A', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          We'll send it to <span style={{ color: '#d92b3c', fontWeight: 'bold' }}>{email || 'your email'}</span>.
        </div>
        <button 
          onClick={handleNotifyMe}
          disabled={isNotifying}
          style={{ 
            background: '#d92b3c', 
            color: '#fff', 
            border: '2px solid #1A1A1A', 
            borderRadius: '8px', 
            padding: '0.6rem 1.25rem', 
            fontWeight: 'bold', 
            fontSize: '0.9rem', 
            cursor: isNotifying ? 'default' : 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.6rem',
            opacity: isNotifying ? 0.7 : 1,
            boxShadow: '3px 3px 0px #1A1A1A',
            transition: 'all 0.2s ease',
          }}>
          {isNotifying && <CircularProgress size={16} style={{ color: '#fff' }} />}
          {!isNotifying && !hasNotified && (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="14" height="14" rx="3" fill="white"/>
            </svg>
          )}
          {hasNotified && (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="14" height="14" rx="3" fill="white"/>
              <path d="M4 7.5L6.5 10L10 4" stroke="#d92b3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
          Notify me at launch
        </button>
        {hasNotified && (
          <div style={{ color: '#666', fontSize: '0.75rem', marginTop: '0.75rem' }}>
            You're on the list.
          </div>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem' }}>
        <button 
          onClick={() => {
            sessionStorage.setItem('skipCaptcha', 'true');
            window.location.reload();
          }}
          style={{ background: '#fff', color: '#d92b3c', border: '1px solid #d92b3c', borderRadius: '8px', padding: '0.5rem 1.25rem', fontWeight: 'bold', fontSize: '0.9rem', cursor: 'pointer' }}
        >
          Value another piece
        </button>
        {getFreeLeftText() && (
          <span style={{ fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px', color: '#999', textTransform: 'uppercase' }}>
            {getFreeLeftText()}
          </span>
        )}
      </div>
    </div>
  );
};

export default SuccessView;
